// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_c0-4";
export var collapsed = "_c0-1";
export var headerBar = "_c0-0";
export var leftHeaderContent = "_c0-3";
export var subjectContainer = "_c0-2";